import { useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { changePassword, deleteAccount, resendVerification } from "@/lib/identity/identity-api";

export function AccountSettingsPage({ user, token, onLogout }) {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [deletePw, setDeletePw] = useState("");
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  if (!token) {
    return (
      <div className="max-w-lg mx-auto px-4 py-24">
        <Card>
          <CardContent className="pt-6">
            <p className="text-muted-foreground">Sign in to manage your account.</p>
            <Link to="/login" className="text-primary text-sm mt-4 inline-block">
              Sign in
            </Link>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="max-w-lg mx-auto px-4 py-24 space-y-6" data-testid="account-settings">
      <Card>
        <CardHeader>
          <CardTitle>Account</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2 text-sm">
          <p>
            <span className="text-muted-foreground">Email:</span> {user?.email}
          </p>
          <p>
            <span className="text-muted-foreground">Verified:</span>{" "}
            {user?.email_verified ? "Yes" : "No"}
          </p>
          {!user?.email_verified && (
            <Button
              variant="outline"
              size="sm"
              onClick={async () => {
                try {
                  const r = await resendVerification(user.email);
                  setMsg(r.message || "Verification email sent.");
                } catch (e) {
                  setErr(e.response?.data?.error || e.message);
                }
              }}
            >
              Resend verification email
            </Button>
          )}
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Change password</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <Input
            type="password"
            placeholder="Current password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
          />
          <Input
            type="password"
            placeholder="New password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <Button
            onClick={async () => {
              setErr("");
              try {
                await changePassword(token, currentPassword, newPassword);
                setMsg("Password updated.");
                setCurrentPassword("");
                setNewPassword("");
              } catch (e) {
                setErr(e.response?.data?.error || e.message);
              }
            }}
          >
            Update password
          </Button>
        </CardContent>
      </Card>

      <Card className="border-destructive/40">
        <CardHeader>
          <CardTitle className="text-destructive">Delete account</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <Input
            type="password"
            placeholder="Confirm password"
            value={deletePw}
            onChange={(e) => setDeletePw(e.target.value)}
          />
          <Button
            variant="destructive"
            onClick={async () => {
              if (!window.confirm("Permanently delete your account?")) return;
              try {
                await deleteAccount(token, deletePw);
                onLogout?.();
              } catch (e) {
                setErr(e.response?.data?.error || e.message);
              }
            }}
          >
            Delete account
          </Button>
        </CardContent>
      </Card>

      {msg && <p className="text-sm text-muted-foreground">{msg}</p>}
      {err && <p className="text-sm text-destructive">{err}</p>}
      <Link to="/settings/security" className="text-primary text-sm">
        Security settings
      </Link>
    </div>
  );
}
